function AlertMessage({ message, type = "info" }) {
    if (!message) return null;
  
    const styles = {
      success: "border-emerald-200 bg-emerald-50 text-emerald-800",
      error: "border-rose-200 bg-rose-50 text-rose-800",
      info: "border-slate-200 bg-slate-100 text-slate-800",
    };
  
    return (
      <div
        className={`rounded-2xl border px-4 py-3 text-sm font-medium ${styles[type]}`}
      >
        {message}
      </div>
    );
  }
  
  export default AlertMessage;